import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';

// import * as AppPropTypes from '../../lib/PropTypes';
import styles from '../../../styles/partials/points-to-chances-banner.module.scss';

const propTypes = {
    className: PropTypes.string,
    description: PropTypes.string,
    points: PropTypes.number,
    chances: PropTypes.number,
};

const defaultProps = {
    className: null,
    description: null,
    points: 200,
    chances: 1,
};

function PointsToChancesBanner({ className, description, points, chances }) {
    const { name: theme = null, isVariant } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const defaultText = isVariant('allstar') ? (
        <FormattedMessage
            defaultMessage="Each time you earn {points, plural, =0 {# point} one {# point} other {# points}}, you get a shot at winning the grand prize!"
            description="PointsToChancesBanner description"
            values={{ points }}
        />
    ) : (
        <FormattedMessage
            defaultMessage="Each time you earn {points, plural, =0 {# point} one {# point} other {# points}}, you get a shot at winning one of the weekly and grand prizes too!"
            description="PointsToChancesBanner description"
            values={{ points }}
        />
    );
    return (
        <div className={classNames([styles.container, themeClassName, className])}>
            <div className={styles.banner}>
                <div className={styles.inner}>
                    <span className={styles.points}>
                        <FormattedMessage
                            defaultMessage="{count, plural, =0 {# pt} one {# pt} other {# pts}}"
                            description="pts label"
                            values={{ count: points }}
                        />
                    </span>
                    <span className={styles.equals}>=</span>
                    <span className={styles.chances}>
                        <FormattedMessage
                            defaultMessage="{count, plural, =0 {# chance} one {# chance} other {# chances}}"
                            description="PointsToChancesBanner chances label"
                            values={{ count: chances }}
                        />
                    </span>
                </div>
                <div className={styles.arrow} />
            </div>
            <div className={styles.description}>
                {description || (theme !== 'nfl' ? defaultText : null)}
            </div>
        </div>
    );
}

PointsToChancesBanner.propTypes = propTypes;
PointsToChancesBanner.defaultProps = defaultProps;

export default PointsToChancesBanner;
